<bp-lottie-player animationName="unread-email-notification" eager></bp-lottie-player>
